import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { TCalendlyType } from '@shared/types/calendly-types';
import createCrudService from '@src/core/api/create-crud-service';

export type TCalendlyQuery = {
  name?: string;
  page_number?: number;
  page_size?: number;
  is_tracked?: boolean;
};

export const calendlyTypeApi = createCrudService<TCalendlyType, TCalendlyQuery>(
  {
    queryKey: [QUERY_KEYS.getCalendlyTypes],
    url: 'calendly/event-types',
  }
);
